var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-press"},[_c('div',{staticClass:"logo-wrap"},_vm._l((_vm.press_logo),function(logo,i){return _c('div',{key:i,staticClass:"item-img"},[_c('a',{attrs:{"href":logo.site_link,"target":"_blanl"}},[_c('img',{attrs:{"src":logo.logo_link,"alt":""}}),_c('span',[_vm._v(_vm._s(logo.publish_date))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }